import {ACTION_TYPES} from "../../../core/consts";
import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {
  WebsiteModuleBolaoFloatingButtonDisplayEvent
} from "../models/bolao/website-module.bolao.floating-button.display-event";

export class WebsiteModuleFloatingButtonDisplayEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.floatingButtonDisplayEvent;

  async action(params) {
    const sendParams = {
      ...params,
      source: this.getScreen(this.state.currentLinkModel?.name),
    }

    const event: WebsiteModuleBolaoFloatingButtonDisplayEvent = new WebsiteModuleBolaoFloatingButtonDisplayEvent(sendParams);

    this.analyticsService.createEvent(event);
  }
}
